/**
 * Menu Empty State Component
 * Empty state specific to menu items with AI import option
 */

import { Plus, Sparkles } from 'lucide-react';
import React from 'react';
import documentsAnimation from '../../../../assets/lottie/documents_scan.json';
import { LottieAnimation } from '../../../common/LottieAnimation';

interface MenuEmptyStateProps {
  searchQuery?: string;
  canManageMenu?: boolean;
  onCreateItem?: () => void;
  onImportWithAI?: () => void;
}

export const MenuEmptyState: React.FC<MenuEmptyStateProps> = ({
  canManageMenu = true,
  searchQuery,
  onCreateItem,
  onImportWithAI,
}) => {
  const hasSearch = searchQuery && searchQuery.length > 0;

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-12 text-center">
      <div className="w-40 h-40 mx-auto mb-4">
        <LottieAnimation animationData={documentsAnimation} />
      </div>

      <h3 className="text-lg font-medium text-gray-900 mb-2">
        {hasSearch ? 'No menu items found' : 'Start building your menu'}
      </h3>
      <p className="text-gray-500 mb-6 max-w-md mx-auto">
        {hasSearch
          ? 'No items match your search. Try a different query or clear the filter.'
          : canManageMenu
            ? 'Create your first menu item manually or let AI extract items from your existing menu document.'
            : 'Menu items added for this outlet will appear here once an authorized user creates them.'}
      </p>

      {!hasSearch && canManageMenu && onCreateItem && onImportWithAI && (
        <div className="flex items-center justify-center gap-3">
          <button
            type="button"
            onClick={onCreateItem}
            className="inline-flex items-center gap-2 px-4 py-2 bg-pos-primary text-white rounded-lg hover:bg-pos-secondary transition-colors"
          >
            <Plus size={18} />
            <span>Create Item</span>
          </button>
          <button
            type="button"
            onClick={onImportWithAI}
            className="inline-flex items-center gap-2 px-4 py-2 border border-pos-primary text-pos-primary rounded-lg hover:bg-pos-light/10 transition-colors"
          >
            <Sparkles size={18} />
            <span>Import with AI</span>
          </button>
        </div>
      )}
    </div>
  );
};
